module.exports = __webpack_public_path__ + "img/Ken.ddd20720.jpg";